<div>
  <a id="imprintLink" [routerLink]="imprintRoute" target="_blank">
    {{ "GENERAL.IMPRINT-LINKNAME" | translate }}
  </a>
  -
  <a id="dataSecurityLink" [routerLink]="dataSecurityRoute" target="_blank">
    {{ "GENERAL.DATA-SECURITY-LINKNAME" | translate }}
  </a>
  -
  <span id="currentYear">{{ currentYear }}</span>
  @if (brandingData()?.title; as title) {
    {{ title }}
  }
</div>
